// Thin wrapper around lz-string. Used for URL hash compression of long DSL.
import LZString from 'lz-string';

export function compress(s: string): string {
  return LZString.compressToEncodedURIComponent(s);
}

export function decompress(s: string): string | null {
  try {
    const out = LZString.decompressFromEncodedURIComponent(s);
    return out === null || out === '' ? null : out;
  } catch {
    return null;
  }
}
